export const NAME = 'modules';
